import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@insights-ltd/design-library/components';

export type ErrorDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string;
};

const ErrorDialog = ({ open, onClose, title, body }: ErrorDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      open={open}
      onClose={onClose}
      title={title}
      content={
        <Box
          sx={{
            height: 180,
          }}
        >
          <DialogContentText
            id="dialog-description"
            color="textSecondary"
            variant="body1"
          >
            {body}
          </DialogContentText>
        </Box>
      }
      secondaryButtonText={t(
        'ui.event-management.learners.teams.error-dialog.confirm',
      )}
    />
  );
};

export default ErrorDialog;
